import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Button, Spinner, Row, Col, Card, Alert, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../ComponentsCss/Iam.css";
import { useAuth } from "../../contexts/AuthContext";

const ManageUsersContent = ({ userData }) => {
 const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
const [selectedUserAction, setSelectedUserAction] = useState(null);

  const { profile } = useAuth();
  const orgId = profile?.orgId;
  const currentUserEmail = profile?.email; // Get current user's email

  const btnPrimary = {
  padding: "7px 16px", borderRadius: "8px", fontSize: "12px", fontWeight: 600, 
   cursor: "pointer", border: "none",backgroundColor:"#024A82",
   fontFamily:"'Inter', sans-serif",
   display: "inline-flex",
  alignItems: "center", gap: "5px",
};


  const openRoleConfirmModal = (user, newRole) => {
  setSelectedUserAction({
    userId: user.id,
    userEmail: user.email,
    currentRole: user.role,
    newRole,
  });
  setShowConfirmModal(true);
};

const closeRoleConfirmModal = () => {
  setShowConfirmModal(false);
  setSelectedUserAction(null);
};

const confirmRoleChange = () => { 
  if (!selectedUserAction) return;

  updateRole(
    selectedUserAction.userId,
    selectedUserAction.newRole,
    selectedUserAction.userEmail
  );

  closeRoleConfirmModal();
};

  useEffect(() => {
    if (orgId) fetchUsers();
  }, [orgId]);

  const disableRightClick = (e) => {
    e.preventDefault();
  };

  const fetchUsers = async () => {
    setLoading(true);
    setError("");
    try {
      const region = sessionStorage.getItem("userRegion") || "AP";
      const res = await axios.get(
        `https://iffud7s7y3.execute-api.ap-southeast-2.amazonaws.com/prod/api/org/${orgId}/users`,
        { headers: { Region: region } },
      );
      setUsers(res.data);
    } catch (err) {
      console.error("Failed to fetch users", err);
      setError("Failed to fetch users. Please try again.");
    }
    setLoading(false);
  };

  const updateRole = async (userId, newRole, userEmail) => {
    setUpdateLoading(true);
    setError("");
    setSuccess("");
    try {
      const region = sessionStorage.getItem("userRegion") || "AP";
      await axios.put(
        `https://u1fmk2tjfi.execute-api.ap-southeast-2.amazonaws.com/prod/api/org/${orgId}/users/${userId}/role`,
        { role: newRole },
        { headers: { Region: region } },
      );
      setSuccess(`Successfully updated role for ${userEmail}`);
      fetchUsers();
    } catch (err) {
      console.error("Failed to update role", err);
      setError(`Failed to update role for ${userEmail}. Please try again.`);
    }
    setUpdateLoading(false);
  };

  // Check if user is the current logged-in user
  const isCurrentUser = (userEmail) => {
    return currentUserEmail === userEmail;
  };

  // Mock module progress - you can replace with actual data
  const moduleProgress = {
    ManageUsers: {
      completed: users.length,
      total: users.length,
    },
  };

  return (
    <>
      <div onContextMenu={disableRightClick}>
        {(loading || updateLoading) && (
          <div className="loading-overlay">
            <Spinner animation="border" variant="primary" />
          </div>
        )}

        <Col className=" p-4">
          <div className="manage-users-container">
            <h3
              style={{
                fontFamily: "Inter, Arial, sans-serif",
                marginBottom: "2rem",
                fontWeight: "600",
              }}
            >
              Manage Organization Users
            </h3>

            {error && (
              <Alert variant="danger" dismissible onClose={() => setError("")}>
                {error}
              </Alert>
            )}

            {success && (
              <Alert
                variant="success"
                dismissible
                onClose={() => setSuccess("")}
              >
                {success}
              </Alert>
            )}

            <Card
              className="mb-4 shadow-sm"
              style={{
                border: "1px solid #e2e8f0",
                borderRadius: "16px",
                overflow: "hidden",
                backgroundColor: "#f9fbff",
              }}
            >
              {/* Top meta bar */}
              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  padding: "0.6rem 1.25rem",
                  backgroundColor: "#f1f5f9",
                  borderBottom: "1px solid #e2e8f0",
                  fontFamily: "Inter, Arial, sans-serif",
                  fontSize: "0.78rem",
                  color: "#64748b",
                }}
              >
                <span>
                  <i className="fas fa-shield-alt me-1"></i>
                  Access control · Organization
                </span>
                <span>
                  Active members:
                  <span
                    className="ms-1 fw-semibold"
                    style={{ color: "#035EA5" }}
                  >
                    {users.length}
                  </span>
                </span>
              </div>

              {/* Main header */}
              <Card.Header
                className="d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: "#ffffff",
                  borderBottom: "1px solid #e2e8f0",
                  padding: "0.9rem 1.25rem",
                  fontFamily: "Inter, Arial, sans-serif",
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: "0.95rem",
                      fontWeight: 600,
                      color: "#0f172a",
                    }}
                  >
                    Organization Members
                  </div>
                  <div
                    style={{
                      fontSize: "0.8rem",
                      color: "#64748b",
                      marginTop: "0.15rem",
                    }}
                  >
                    Review member roles and keep your workspace secure.
                  </div>
                </div>

                <div
                  className="d-flex align-items-center"
                  style={{ gap: "0.5rem", fontSize: "0.78rem" }}
                >
                  <span
                    className="badge rounded-pill"
                    style={{
                      backgroundColor: "#ecfeff",
                      color: "#0e7490",
                      padding: "0.35rem 0.75rem",
                    }}
                  >
                    <i className="fas fa-user-lock me-1"></i>
                    Role based access
                  </span>
                </div>
              </Card.Header>

              {/* Body */}
              <Card.Body style={{ padding: 0, backgroundColor: "#ffffff" }}>
                {loading ? (
                  <div className="text-center p-4">
                    <Spinner animation="border" style={{ color: "#0ea5e9" }} />
                    <p
                      className="mt-2"
                      style={{
                        color: "#0f172a",
                        fontFamily: "Inter, Arial, sans-serif",
                        fontSize: "0.85rem",
                      }}
                    >
                      Loading members...
                    </p>
                  </div>
                ) : users.length === 0 ? (
                  <div className="text-center p-4">
                    <p
                      style={{
                        color: "#64748b",
                        fontFamily: "Inter, Arial, sans-serif",
                        fontSize: "0.85rem",
                      }}
                    >
                      No users found in this organization.
                    </p>
                  </div>
                ) : (
                  <div
                    style={{
                      maxHeight: "420px", // adjust height as you like
                      overflowY: "auto",
                      overflowX: "hidden",
                      marginLeft: "-10px",
                    }}
                  >
                    <Table
                      hover
                      responsive
                      className="mb-0"
                      style={{
                        fontFamily: "Inter, Arial, sans-serif",
                        fontSize: "0.86rem",
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            backgroundColor: "#f8fafc",
                            borderBottom: "1px solid #e2e8f0",
                          }}
                        >
                          <th
                            style={{
                              color: "#475569",
                              fontWeight: 600,
                              paddingTop: "0.75rem",
                              paddingBottom: "0.75rem",
                            }}
                          >
                            Member
                          </th>
                          <th
                            style={{
                              color: "#475569",
                              fontWeight: 600,
                            }}
                          >
                            Role
                          </th>
                          <th
                            style={{
                              color: "#475569",
                              fontWeight: 600,
                            }}
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {users.map((user, index) => (
                          <tr
                            key={user.userId}
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#ffffff" : "#f9fafb",
                            }}
                          >
                            <td
                              style={{
                                color: "#0f172a",
                                verticalAlign: "middle",
                                paddingTop: "0.7rem",
                                paddingBottom: "0.7rem",
                              }}
                            >
                              <div className="d-flex align-items-center">
                                <div
                                  className="d-flex align-items-center justify-content-center me-2"
                                  style={{
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "999px",
                                    backgroundColor: "#e0f2fe",
                                    color: "#0369a1",
                                    fontSize: "0.8rem",
                                    fontWeight: 600,
                                  }}
                                >
                                  {user.email.charAt(0).toUpperCase()}
                                </div>
                                <div>
                                  <div>{user.email}</div>
                                  {isCurrentUser(user.email) && (
                                    <div
                                      style={{
                                        fontSize: "0.72rem",
                                        color: "#16a34a",
                                        marginTop: "0.05rem",
                                      }}
                                    >
                                      <i className="fas fa-check-circle me-1"></i>
                                      Signed in as you
                                    </div>
                                  )}
                                </div>
                              </div>
                            </td>

                             <td style={{ verticalAlign: "middle" }}>
                                                         <span
                                                          
                                                           style={{
                                                            display: "inline-block",
                                 padding: "0",
                                 borderRadius: "0",
                                 fontSize: "13px",
                                 fontWeight: 600,
                                 letterSpacing: "0.3px",
                                 backgroundColor: "transparent",
                                 color: user.role === "ADMIN" ? "#035EA5" : "#334155",
                                 textTransform: "uppercase",
                                                           }}
                                                         >
                                                           {user.role === "ADMIN"
                                                             ? "Administrator"
                                                             : "User"}
                                                         </span>
                                                       </td>
                           
                                                       <td style={{ verticalAlign: "middle" }}>
                                                         {isCurrentUser(user.email) ? (
                                                           <span
                                                             style={{
                                                               color: "#9ca3af",
                                                               fontStyle: "italic",
                                                               fontSize: "0.8rem",
                                                             }}
                                                           >
                                                             <i className="fas fa-lock me-1"></i>
                                                             Cannot modify own role
                                                           </span>
                                                         ) : user.role === "USER" ? (
                                                           <Button
                             
                             style={{
                               backgroundColor: "#035EA5",
                               border: "none",
                               borderRadius: "5%",
                               padding: "10px 26px",
                               fontWeight: 600,
                               fontSize: "14px",
                               color: "#ffffff",
                               ...btnPrimary
                             }}
                             onClick={() => openRoleConfirmModal(user, "ADMIN")}
                              disabled={updateLoading}
                           >
                             Promote to admin
                           </Button>
                                                         ) : (
                                                           <Button
                            
                             style={{
                               backgroundColor: "#f3d9d9",
                               padding: "7px 16px", borderRadius: "8px", fontSize: "12px", fontWeight: 600, 
                              cursor: "pointer", border: "none",
                              fontFamily:"'Inter', sans-serif",
                              display: "inline-flex",
                             alignItems: "center", gap: "5px",
                               color: "#b42318",
                             }}
                             onClick={() => openRoleConfirmModal(user, "USER")}
                              disabled={updateLoading}
                           >
                             Remove admin
                           </Button>
                                                         )}
                                                       </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </Card.Body>

                <Modal
  show={showConfirmModal}
  onHide={closeRoleConfirmModal}
  centered
  backdrop="static" 
>
  <Modal.Header closeButton style={{height:"40px"}} className="custom-modal-header">
    <Modal.Title>
      {selectedUserAction?.newRole === "ADMIN"
        ? "Confirm Admin Assignment"
        : "Confirm Admin Removal"}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {selectedUserAction?.newRole === "ADMIN" ? (
      <>
        Are you sure you want to assign <strong>Admin</strong> role to{" "}
        <strong>{selectedUserAction?.userEmail}</strong>?
      </>
    ) : (
      <>
        Are you sure you want to remove <strong>Admin</strong> role from{" "}
        <strong>{selectedUserAction?.userEmail}</strong>?
      </>
    )}
  </Modal.Body>

  <Modal.Footer >
    <Button
      variant="secondary"
      onClick={closeRoleConfirmModal}
      disabled={updateLoading}
      style={{ padding: "7px 10px", borderRadius: "8px", fontSize: "12px", fontWeight: 600, 
   cursor: "pointer", border: "none",
   fontFamily:"'Inter', sans-serif",
   display: "inline-flex",
  alignItems: "center", gap: "5px",}}
    >
      Cancel
    </Button>
    <Button
      onClick={confirmRoleChange}
      disabled={updateLoading}
      style={{
         padding: "7px 16px", borderRadius: "8px", fontSize: "12px", fontWeight: 600, 
   cursor: "pointer", border: "none",
   fontFamily:"'Inter', sans-serif",
   display: "inline-flex",
  alignItems: "center", gap: "5px",
        backgroundColor:
          selectedUserAction?.newRole === "ADMIN" ? "#024A82" : "#b42318",
      
        color: "#ffffff",
      }}
    >
      {updateLoading
        ? "Processing..."
        : selectedUserAction?.newRole === "ADMIN"
        ? "Yes, Assign Admin"
        : "Yes, Remove Admin"}
    </Button>
  </Modal.Footer>
</Modal>


              {/* Footer */}
              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  padding: "0.6rem 1.25rem",
                  borderTop: "1px solid #e2e8f0",
                  backgroundColor: "#f8fafc",
                  fontFamily: "Inter, Arial, sans-serif",
                  fontSize: "0.78rem",
                  color: "#64748b",
                }}
              >
                <span>
                  Changes to roles are applied instantly and logged for audit.
                </span>
                <span style={{ color: "#035EA5" }}>srql.com</span>
              </div>
            </Card>
          </div>
        </Col>
      </div>
    </>
  );
};

export default ManageUsersContent;
